<div *ngIf="vm" id="contact-form-panel-header-component">
  <img [src]="vm.titleIconPath" alt="header icon" />
  <h1>
    <span>{{ vm.title }}</span>
  </h1>
</div>
